'use client';

import * as React from 'react';

import { trackCta } from '~/lib/track-cta';

/**
 * Delegated click tracking for CTA links inside blog post bodies (MDX links
 * can't call trackCta themselves). Fires `blog_cta_clicked` for links to the
 * pricing page, the site root, tool pages, or the app (the CTA targets posts
 * use); the event's automatic `page` property identifies the post.
 */
export function BlogCtaTracker({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const handleClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (event.target as HTMLElement).closest('a');
    if (!anchor?.getAttribute('href')) {
      return;
    }
    const url = new URL(anchor.href, window.location.origin);
    const isCta =
      url.pathname === '/pricing' ||
      url.pathname === '/' ||
      url.pathname.startsWith('/tools/') ||
      url.hostname.startsWith('app.');
    if (isCta) {
      trackCta('blog_cta_clicked', { href: anchor.getAttribute('href') ?? '' });
    }
  };

  return <div onClickCapture={handleClickCapture}>{children}</div>;
}
